import produce from 'immer';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import { IPaginatedStoreResource } from '../helpers/pagination';
import { initialRootState } from '../initialRootState';
import { EPhotoRequestsActionType, TPhotoRequestsAction } from './actions';
import { TPhotoRequestsEntries } from './types';

export interface IPhotoRequestsState extends IPaginatedStoreResource {
  entries: TPhotoRequestsEntries;
  list: string[];
}

export const photoRequestsReducer = (
  currentState: IPhotoRequestsState = initialRootState.photoRequests,
  action: TPhotoRequestsAction
): IPhotoRequestsState =>
  produce(currentState, draft => {
    switch (action.type) {
      case EPhotoRequestsActionType.RESET:
        draft = initialRootState.photoRequests;
        break;
      case EPhotoRequestsActionType.GET_SUCCESS:
        const {
          meta: {
            pagination: { current_page: currentPage, total },
          },
          data,
        } = action.payload.result;

        draft.list = currentPage > 1 ? draft.list.concat(data) : data;
        draft.entries =
          currentPage > 1
            ? {
                ...draft.entries,
                ...action.payload.entities.photoRequests,
              }
            : action.payload.entities.photoRequests;
        draft.meta = { currentPage, total };
        break;
      case EPhotoRequestsActionType.ANSWER_PHOTO_REQUEST_SUCCESS:
        draft.list = draft.list.filter(id => id !== action.payload.idToRemove);
        draft.entries = omit(draft.entries, [action.payload.idToRemove]);
        draft.meta = merge(draft.meta, {
          // the right part of this ternary condition should never be called because if total is undefined or equals 0 the success action cannot be called
          total: draft.meta.total ? draft.meta.total - 1 : 0,
        });
        break;
    }
  });
